import React, {  } from "react";
import { } from "react-router";

import "bootstrap/dist/css/bootstrap.min.css";
//import logo from "./logo_clean_verify.png"
import "../../../App.css";

import logoUni from '../../../logo-unilimpio.svg';

const version = process.env.REACT_APP_VERSION

//import AuthVerify from "./common/AuthVerify";
//import EventBus from "./common/EventBus";

const Footer = () => {

  const currentDate = new Date();

  const dateString = currentDate.toLocaleDateString("en-US", { year: "numeric" })


  return (
    
      <footer className="fixed w-full h-16 flex justify-between z-20 bottom-0 right-0 bg-slate-800">
        
        <div className="flex-col">
          <p className="text-[8px] font-light text-white m-1">{`v.${version}`}</p>
          <p className="content-end text-sky-900 text-[8px] font-light mb-0 opacity-90">
            &copy;MFC - All rights reserved {dateString}
          </p>
        </div>
          
        
        
        <div className="w-1/3 p-1 bg-gradient-to-r from-transparent to-sky-600">  
          <div className="flex justify-end ">
            <p className="text-white text-[8px] font-thin text-shadow-lg">
             con el respaldo de:
            </p>
            <a href="https://unilimpio.com/"> 
              <img src={logoUni} alt="logo Unilimpio" className=" w-12 h-12 sm:w-11 sm:h-11 md:w-12 md:h-12   " />
            </a>
          </div>
        </div>  
        


        
         
      </footer>
      
   
  );
};

export default Footer;
